import axios from "axios";
import { isUndefined } from "lodash";

export const getConfig = async () => {
	const configPath = getConfigPath(true);

	try {
		const res = await axios.get(configPath);

		if (res.status === 200) {
			const config = { ...res.data };

			return config;
		} else {
			return false;
		}
	} catch (error) {
		return false;
	}
};

export const getConfigPath = (returnPath = false) => {
	const configPath = isUndefined(process.env.REACT_APP_CONFIG_LOCAL)
		? "./static/config/config.json"
		: "./static/config/config.sandbox.json";

	if (returnPath) {
		return configPath;
	}

	return [configPath];
};
